var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPencil(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9059 0.792245C12.3201 0.206459 11.3703 0.206459 10.7845 0.792245L0.795713 10.7811C0.719911 10.8569 0.670479 10.9551 0.654707 11.0611L0.0369403 15.2144C0.0136372 15.3711 0.0659457 15.5295 0.177947 15.6415C0.289948 15.7535 0.448393 15.8058 0.605062 15.7825L4.75836 15.1647C4.8644 15.149 4.96255 15.0995 5.03835 15.0237L15.0272 5.03489C15.613 4.4491 15.613 3.49935 15.0272 2.91357L12.9059 0.792245ZM9.9458 3.04521L12.7742 5.87363L11.7242 6.92366L8.89578 4.09524L9.9458 3.04521ZM11.3706 7.27722L4.67332 13.9746L1.84489 11.1461L8.54222 4.44879L11.3706 7.27722ZM4.22476 14.2331L2.04585 14.5572L1.26225 13.7736L1.58634 11.5947L4.22476 14.2331Z",
    fill: "#212121"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.756a8e82.svg";
export { ForwardRef as ReactComponent };